module.exports = __webpack_public_path__ + "img/wafe-logo.dark.8b96b5d8.png";